/**
 * @function isEventTargetOnElement
 * @description Determines whether the event target is the specified element or a descendant of it.
 *              Useful for checking if a click or other event occurred within a particular DOM element.
 * @param {HTMLElement} element - The DOM element to check against.
 * @param {Event} event - The event object containing the target.
 * @returns {boolean} True if the event target is the element or a child of it; otherwise, false.
 */
export const isEventTargetOnElement = (element, event) => {
  // Check if the event target is within the specified element.
  if (!element || !event || !event.target) {
    return false;
  }
  // Use the contains method to check if the event target is within the element.
  if (element.contains(event.target)) {
    return true;
  }

  // If the element is not found, return false.
  return false;
};

export default isEventTargetOnElement;